import { render, staticRenderFns } from "./PagePositionField.vue?vue&type=template&id=81ffc9b0&scoped=true"
import script from "./PagePositionField.vue?vue&type=script&lang=ts"
export * from "./PagePositionField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ffc9b0",
  null
  
)

export default component.exports